import React from 'react';

import Percentage from '@/main/components/shared/percentage/percentage';
import KOGRadio from '@/main/components/shared/radioButton/radioButton';
import { MappingPartSuggestionViewResponse } from '@/main/models/response';
import { getTranslateByKey } from '@/main/services/utils';

import * as S from './styles';

interface IRowDetailsMappingPartsProps {
  optionSelected: string
  handleSelectOption: (option: string) => void
  detailsOption: MappingPartSuggestionViewResponse
}
function RowDetailsMappingParts({
  optionSelected,
  handleSelectOption,
  detailsOption
}: IRowDetailsMappingPartsProps) {
  function handleClickRow(e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    e.preventDefault();
    handleSelectOption(detailsOption.order);
  }
  const percentage = detailsOption.confidence * 100;
  const renderXnuupPartId = `${detailsOption.xnuupPartId} (${detailsOption.piesPartId})`
  const renderPiesPosId = `${detailsOption.partPositionName} (${detailsOption.piesPosId})`
  return (
    <S.ContainerRow onClick={handleClickRow}>
      <KOGRadio
        id={`id-mappingParts-radio-${detailsOption.order}`}
        value={detailsOption.order}
        checked={optionSelected === detailsOption.order}
        onChange={(_, checked) => handleSelectOption(checked ? detailsOption.order : '')}
      />

      <S.ContainerLabel $labelContent={getTranslateByKey('quoteCard.category')}><S.ValueOption title={detailsOption.partCategoryName}><S.ValueOptionText>{detailsOption.partCategoryName}</S.ValueOptionText></S.ValueOption></S.ContainerLabel>
      <S.ContainerLabel $labelContent={getTranslateByKey('quoteCard.subCategory')}><S.ValueOption title={detailsOption.partSubCategoryName}><S.ValueOptionText>{detailsOption.partSubCategoryName}</S.ValueOptionText></S.ValueOption></S.ContainerLabel>
      <S.ContainerLabel $labelContent={getTranslateByKey('information.xnuupPartId')}><S.ValueOption title={renderXnuupPartId}><S.ValueOptionText>{renderXnuupPartId}</S.ValueOptionText></S.ValueOption></S.ContainerLabel>
      <S.ContainerLabel $labelContent={getTranslateByKey('information.position')}><S.ValueOption title={renderPiesPosId}><S.ValueOptionText>{renderPiesPosId}</S.ValueOptionText></S.ValueOption></S.ContainerLabel>
      <S.ContainerLabel $labelContent={getTranslateByKey('information.reliabilityPercentage')}><Percentage percentage={percentage} /></S.ContainerLabel>
    </S.ContainerRow>
  )
}

export default RowDetailsMappingParts